import { render, staticRenderFns } from "./bankAccounts.vue?vue&type=template&id=d4750b4a&scoped=true&"
import script from "./bankAccounts.vue?vue&type=script&lang=ts&"
export * from "./bankAccounts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4750b4a",
  null
  
)

export default component.exports